export interface Paquete {
  id: string;
  nombre: string;
  cantidadEnUnidades: number;
  precio: number;
}

export interface Producto {
  id: string;
  nombre: string;
  descripcion: string;
  imagenes: string[];
  categoriaId: string;
  stock: number;
  paquetes: Paquete[];
}

export interface Categoria {
  id: string;
  nombre: string;
}

export type NuevaCategoria = Pick<Categoria, 'nombre'>;

export interface FiltroCatalogo {
  categoriaId?: string;
  texto?: string;
}

export type NuevoProducto = Pick<
  Producto,
  'nombre' | 'descripcion' | 'imagenes' | 'categoriaId' | 'stock' | 'paquetes'
>;

export function estaAgotado(producto: Pick<Producto, 'stock'>): boolean {
  return producto.stock === 0;
}
